'use client';
import { tokens } from '../tokens/index.js';
import { SpacePropType } from '../types/swan-style.types.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r.push.apply(r, n);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
const stylePropertyPrefixes = {
    margin: 'm',
    marginTop: 'mt',
    marginRight: 'mr',
    marginBottom: 'mb',
    marginLeft: 'ml',
    marginX: 'mx',
    marginY: 'my',
    padding: 'p',
    paddingTop: 'pt',
    paddingRight: 'pr',
    paddingBottom: 'pb',
    paddingLeft: 'pl',
    paddingX: 'px',
    paddingY: 'py',
    backgroundColor: 'bgc',
    visuallyHidden: 'visually-hidden',
    textAlign: 'text-align',
    textColor: 'text-color',
    textAllCaps: 'text-all-caps',
    fontWeight: 'font-weight',
    fontSize: 'text',
    fontFamily: 'font',
    fontSkin: 'font-skin',
    standardMode: 'standard-mode',
    darkMode: 'dark-mode',
    compactMode: 'compact-mode',
    loadingShimmer: 'loading-shimmer'
};
const styleValidProperties = new Set([
    "margin",
    "m",
    "marginTop",
    "mt",
    "marginRight",
    "mr",
    "marginBottom",
    "mb",
    "marginLeft",
    "ml",
    "marginX",
    "mx",
    "marginY",
    "my",
    "padding",
    "p",
    "paddingTop",
    "pt",
    "paddingRight",
    "pr",
    "paddingBottom",
    "pb",
    "paddingLeft",
    "pl",
    "paddingX",
    "px",
    "paddingY",
    "py",
    "backgroundColor",
    "bgc",
    "textAlign",
    "textAllCaps",
    "textColor",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "fontSkin",
    "display",
    "standardMode",
    "darkMode",
    "compactMode",
    "overflow",
    "visuallyHidden",
    "loadingShimmer"
]);
const responsiveModifierSet = new Set([
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]);
function isValidStyleProperty(e) {
    return styleValidProperties.has(e);
}
function isResponsiveModifier(e) {
    return responsiveModifierSet.has(e);
}
function getKey(e) {
    return isValidStyleProperty(e) ? stylePropertyPrefixes[e] || e : null;
}
const swanStyleObjectFitValues = [
    'cover',
    'contain',
    'none',
    'unset',
    'fill'
];
function swanStyleObjectFit(e) {
    return e ? `swan-image-fit-${e}` : null;
}
const spaceTokensMap = SpacePropType.reduce((t, r)=>{
    let n = `SwanSemSpace${r}`;
    return n in tokens && 'SwanSemSpace0' !== n ? _object_spread_props(_object_spread({}, t), {
        [r]: tokens[n]
    }) : t;
}, {
    0: tokens.SwanSemSpaceNone
});

export { getKey, isResponsiveModifier, isValidStyleProperty, responsiveModifierSet, spaceTokensMap, stylePropertyPrefixes, styleValidProperties, swanStyleObjectFit, swanStyleObjectFitValues };
